export default {
  title: 'Welcome back!',
  subtitle: 'To sign in just click the magic link we sent to your email',
  resendButton: 'Resend',
}
